// Vivalis Medical Hair — shared interactions
document.addEventListener('DOMContentLoaded', function () {

  // Mobile nav toggle
  var toggle = document.querySelector('.nav-toggle');
  var links = document.querySelector('.nav-links');
  if (toggle && links) {
    toggle.addEventListener('click', function () {
      links.classList.toggle('open');
      var expanded = links.classList.contains('open');
      toggle.setAttribute('aria-expanded', expanded);
    });
    links.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { links.classList.remove('open'); });
    });
  }

  // Highlight current page in nav
  var here = (window.location.pathname.split('/').pop() || 'index.html');
  document.querySelectorAll('.nav-links a').forEach(function (a) {
    var href = a.getAttribute('href');
    if (href === here || (here === '' && href === 'index.html')) {
      a.classList.add('active');
    }
  });

  // Accordion (Insurance / FAQ pages)
  document.querySelectorAll('.accordion-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.accordion-item');
      var panel = item.querySelector('.accordion-panel');
      var isOpen = item.classList.contains('open');

      // close siblings within same accordion group
      var group = item.parentElement;
      group.querySelectorAll('.accordion-item.open').forEach(function (openItem) {
        if (openItem !== item) {
          openItem.classList.remove('open');
          openItem.querySelector('.accordion-panel').style.maxHeight = null;
          openItem.querySelector('.accordion-trigger').setAttribute('aria-expanded', 'false');
        }
      });

      if (isOpen) {
        item.classList.remove('open');
        panel.style.maxHeight = null;
        btn.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Header search toggle
  var searchToggle = document.getElementById('searchToggle');
  var searchForm = document.getElementById('siteSearchForm');
  var searchInput = document.getElementById('siteSearchInput');
  if (searchToggle && searchForm) {
    searchToggle.addEventListener('click', function () {
      searchForm.classList.toggle('open');
      if (searchForm.classList.contains('open') && searchInput) {
        searchInput.focus();
      }
    });
    document.addEventListener('click', function (e) {
      if (!searchForm.contains(e.target) && e.target !== searchToggle && !searchToggle.contains(e.target)) {
        searchForm.classList.remove('open');
      }
    });
  }

  // Shop filter chips — matches against comma-separated Shopify product tags
  var chips = document.querySelectorAll('.filter-chip');
  var products = document.querySelectorAll('[data-category]');
  if (chips.length && products.length) {
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('active'); });
        chip.classList.add('active');
        var cat = chip.getAttribute('data-filter');
        products.forEach(function (p) {
          var tags = (p.getAttribute('data-category') || '').split(',').map(function (t) { return t.trim(); });
          p.style.display = (cat === 'all' || tags.indexOf(cat) !== -1) ? '' : 'none';
        });
      });
    });
  }

});
